document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".slider-container");
  const before = container?.querySelector(".before-image");
  const handle = container?.querySelector(".handle");

  if (!container || !before || !handle) return;

  let isDragging = false;

  container.addEventListener("mousedown", function () {
    isDragging = true;
  });

  container.addEventListener("mouseup", function () {
    isDragging = false;
  });

  container.addEventListener("mousemove", function (e) {
    if (!isDragging) return;

    const rect = container.getBoundingClientRect();
    let offsetX = e.clientX - rect.left;
    offsetX = Math.max(0, Math.min(offsetX, rect.width));

    const percent = (offsetX / rect.width) * 100;
    before.style.width = `${percent}%`;
    handle.style.left = `${percent}%`;
  });
});
